<template lang="html">
	<div class="partners-about">
		<div class="row justify-content-center">
			<div class="col-12 col-md-9 col-lg-8 col-xl-7">
				<div class="center">
					<h2>Our Partners</h2>
					<div class="txt">
						Accidents happen, which is exactly why you have Lorem
						ipsum is placeholder text commonly used in the graphic,
						print, and publishing industries for previewing layouts
						and visual mockups.
					</div>
				</div>
			</div>
			<div class="col-12 col-md-10 col-lg-9 col-xl-8">
				<div class="images">
					<a href="#" target="_blank"
						><img src="/img/partners/partner.png" alt=""
					/></a>
					<a href="#" target="_blank"
						><img src="/img/partners/partner2.png" alt=""
					/></a>
					<a href="#" target="_blank"
						><img src="/img/partners/partner3.png" alt=""
					/></a>
					<a href="#" target="_blank"
						><img src="/img/partners/partner4.png" alt=""
					/></a>
					<a href="#" target="_blank"
						><img src="/img/partners/partner5.png" alt=""
					/></a>
					<a href="#" target="_blank"
						><img src="/img/partners/partner6.png" alt=""
					/></a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {},
	computed: {
		...mapGetters([]),
	},
	methods: {
		...mapActions([]),
	},
	mounted() {},
};
</script>

<style lang="less">
.partners-about {
	background-color: var(--white);
	background-color: #f7f8fc;
	padding: 20px 0 60px 0;

	.images {
		text-align: center;
		margin: 40px 0 0 0;

		img {
			width: auto;
			height: auto;
			max-width: 100px;
			max-height: 100px;
			margin: 20px 30px;
		}
	}
	.center {
		text-align: center;
	}
	h3 {
		font-size: 20px;
		opacity: 0.4;
	}
	h2 {
		font-size: 30px;
		margin: 40px 0 0 0;
		color: #6b6f81;
	}
	.txt {
		font-size: 14px;
		opacity: 0.8;
		margin: 40px 0 0 0;
	}
}
</style>
